import React, { createContext, useContext, useState, ReactNode } from 'react';

type Language = 'PL' | 'EN';

interface Translations {
  [key: string]: {
    PL: string;
    EN: string;
  };
}

export const translations: Translations = {
  heroTitle: {
    PL: 'Włoska piwnica',
    EN: 'Italian Cellar',
  },
  heroSubtitle: {
    PL: 'Naturalne wina z beczki',
    EN: 'Natural barrel wines',
  },
  terms: {
    PL: 'Regulamin',
    EN: 'Terms & Conditions',
  },
  privacyPolicy: {
    PL: 'Polityka Prywatności',
    EN: 'Privacy Policy',
  },
  naturalWines: {
    PL: 'WINA NATURALNE',
    EN: 'NATURAL WINES',
  },
  bioFarming: {
    PL: 'UPRAWA BIO - BEZ NAWOZÓW SZTUCZNYCH',
    EN: 'BIO FARMING - NO ARTIFICIAL FERTILIZERS',
  },
  certified: {
    PL: 'CERTYFIKOWANA JAKOŚĆ',
    EN: 'CERTIFIED QUALITY',
  },
  aboutUs: {
    PL: 'O nas',
    EN: 'About us',
  },
  exploreCategory: {
    PL: 'Sprawdź',
    EN: 'Check',
  },
  history: {
    PL: 'Nasi dostawcy',
    EN: 'Our suppliers',
  },
  redWine: {
    PL: 'Wino Czerwone',
    EN: 'Red Wine',
  },
  whiteWine: {
    PL: 'Wino Białe',
    EN: 'White Wine',
  },
  roseWine: {
    PL: 'Wino Różowe',
    EN: 'Rosé Wine',
  },
  italianProducts: {
    PL: 'Włoskie produkty',
    EN: 'Italian Products',
  },
  oil: {
    PL: 'Oliwa',
    EN: 'Olive Oil',
  },
  olives: {
    PL: 'Oliwki',
    EN: 'Olives',
  },
  cheese: {
    PL: 'Sery',
    EN: 'Cheese',
  },
  snacks: {
    PL: 'Przekąski',
    EN: 'Snacks',
  },
  forGift: {
    PL: 'Na Prezent',
    EN: 'Gift Sets',
  },
  accessories: {
    PL: 'Dodatki',
    EN: 'Accessories',
  },
  contact: {
    PL: 'Kontakt',
    EN: 'Contact',
  },
  addToCart: {
    PL: 'Dodaj do koszyka',
    EN: 'Add to cart',
  },
  cart: {
    PL: 'Koszyk',
    EN: 'Cart',
  },
  buy: {
    PL: 'Kup teraz',
    EN: 'Buy now',
  },
  ageGateTitle: {
    PL: 'POTWIERDZENIE WIEKU',
    EN: 'AGE VERIFICATION',
  },
  ageGateText: {
    PL: 'Ta strona zawiera treści przeznaczone wyłącznie dla osób pełnoletnich.',
    EN: 'This website contains content intended only for adults.',
  },
  ageGateConfirm: {
    PL: 'MAM UKOŃCZONE 18 LAT',
    EN: 'I AM 18 OR OLDER',
  },
  ageGateDeny: {
    PL: 'Nie mam 18 lat',
    EN: 'I am under 18',
  },
  gallery: {
    PL: 'Galeria',
    EN: 'Vineyard Gallery',
  },
  openingHours: {
    PL: 'Godziny otwarcia',
    EN: 'Opening hours',
  },
  events: {
    PL: 'Aktywne działania, wydarzenia i promocje',
    EN: 'Activities, events and promotions',
  },
  followUs: {
    PL: 'Obserwuj nas',
    EN: 'Follow us',
  },
  total: {
    PL: 'Suma',
    EN: 'Total',
  },
  emptyCart: {
    PL: 'Twój koszyk jest pusty',
    EN: 'Your cart is empty',
  },
  checkout: {
    PL: 'Zamów',
    EN: 'Checkout',
  },
  region: {
    PL: 'Region',
    EN: 'Region',
  },
  year: {
    PL: 'Rocznik',
    EN: 'Year',
  },
  allRegions: {
    PL: 'Wszystkie regiony',
    EN: 'All regions',
  },
  allYears: {
    PL: 'Wszystkie roczniki',
    EN: 'All years',
  },
  orderForm: {
    PL: 'Formularz zamówienia',
    EN: 'Order Form',
  },
  name: {
    PL: 'Imię i nazwisko',
    EN: 'Full name',
  },
  firstName: {
    PL: 'Imię',
    EN: 'First name',
  },
  lastName: {
    PL: 'Nazwisko',
    EN: 'Last name',
  },
  email: {
    PL: 'Email',
    EN: 'Email',
  },
  phone: {
    PL: 'Telefon',
    EN: 'Phone',
  },
  address: {
    PL: 'Adres dostawy',
    EN: 'Delivery address',
  },
  paymentMethod: {
    PL: 'Metoda płatności',
    EN: 'Payment method',
  },
  bankTransfer: {
    PL: 'Przelew bankowy',
    EN: 'Bank transfer',
  },
  creditCard: {
    PL: 'Karta płatnicza',
    EN: 'Credit card',
  },
  placeOrder: {
    PL: 'Złóż zamówienie',
    EN: 'Place order',
  },
  back: {
    PL: 'Powrót',
    EN: 'Back',
  },
  backToHome: {
    PL: 'Wróć do strony głównej',
    EN: 'Back to home',
  },
  productNotFound: {
    PL: 'Produkt nie został znaleziony',
    EN: 'Product not found',
  },
  volume: {
    PL: 'Pojemność',
    EN: 'Volume',
  },
  weight: {
    PL: 'Waga',
    EN: 'Weight',
  },
  alcohol: {
    PL: 'Alkohol',
    EN: 'Alcohol',
  },
  servingTemp: {
    PL: 'Temp. serwowania',
    EN: 'Serving temp.',
  },
  aging: {
    PL: 'Dojrzewanie',
    EN: 'Aging',
  },
  grapeVariety: {
    PL: 'Szczep',
    EN: 'Grape variety',
  },
  pairing: {
    PL: 'Podawaj z',
    EN: 'Pairs with',
  },
  contents: {
    PL: 'Zawartość zestawu',
    EN: 'Set contents',
  },
  exploreWines: {
    PL: 'Odkryj nasze wina',
    EN: 'Explore our wines',
  },
  browseCategories: {
    PL: 'Przeglądaj kategorie',
    EN: 'Browse categories',
  },
  allProducts: {
    PL: 'Wszystkie Produkty',
    EN: 'All Products',
  },
  productsFound: {
    PL: 'produktów',
    EN: 'products found',
  },
  allCategories: {
    PL: 'Wszystkie kategorie',
    EN: 'All categories',
  },
  wines: {
    PL: 'Wina',
    EN: 'Wines',
  },
  featuredProducts: {
    PL: 'Polecane produkty',
    EN: 'Featured Products',
  },
  ourSelection: {
    PL: 'Nasz wybór',
    EN: 'Our selection',
  },
  featuredDescription: {
    PL: 'Odkryj nasze najlepsze produkty - starannie wyselekcjonowane wina i włoskie specjały',
    EN: 'Discover our best products - carefully selected wines and Italian specialties',
  },
  showMore: {
    PL: 'Zobacz wszystkie produkty',
    EN: 'View all products',
  },
  discoverMore: {
    PL: 'Odkryj więcej',
    EN: 'Discover more',
  },
  // PromoBanner
  promoText: {
    PL: 'Wiosenna promocja! -15% na wszystkie wina z kodem',
    EN: 'Spring sale! -15% on all wines with code',
  },
  // TrustBadges
  trustFreeShipping: {
    PL: 'Darmowa dostawa',
    EN: 'Free shipping',
  },
  trustFreeShippingDesc: {
    PL: 'Dla zamówień od {threshold} zł',
    EN: 'On orders over {threshold} PLN',
  },
  trustSecurePayment: {
    PL: 'Bezpieczne płatności',
    EN: 'Secure payments',
  },
  trustSecurePaymentDesc: {
    PL: 'Szyfrowane połączenie SSL',
    EN: 'SSL encrypted connection',
  },
  trustReturn: {
    PL: '14 dni na zwrot',
    EN: '14-day returns',
  },
  trustReturnDesc: {
    PL: 'Gwarancja satysfakcji',
    EN: 'Satisfaction guaranteed',
  },
  trustCertified: {
    PL: 'Certyfikowane wina',
    EN: 'Certified wines',
  },
  trustCertifiedDesc: {
    PL: 'Bezpośrednio z winnicy',
    EN: 'Directly from vineyard',
  },
  // Testimonials
  testimonialsLabel: {
    PL: 'Opinie klientów',
    EN: 'Customer reviews',
  },
  testimonialsTitle: {
    PL: 'Co mówią nasi klienci',
    EN: 'What our customers say',
  },
  testimonialsSubtitle: {
    PL: 'Dołącz do grona zadowolonych klientów, którzy pokochali autentyczne włoskie smaki',
    EN: 'Join our satisfied customers who fell in love with authentic Italian flavors',
  },
  testimonialsBasedOn: {
    PL: 'na podstawie opinii naszych klientów',
    EN: 'based on our customer reviews',
  },
  // Newsletter
  newsletterTitle: {
    PL: 'Otrzymaj 10% rabatu',
    EN: 'Get 10% off',
  },
  newsletterSubtitle: {
    PL: 'Zapisz się do newslettera i odbierz kod rabatowy na pierwsze zamówienie. Bądź na bieżąco z nowościami i promocjami!',
    EN: 'Subscribe to our newsletter and receive a discount code for your first order. Stay up to date with news and promotions!',
  },
  newsletterPlaceholder: {
    PL: 'Twój adres email',
    EN: 'Your email address',
  },
  newsletterButton: {
    PL: 'Zapisz się',
    EN: 'Subscribe',
  },
  newsletterSuccess: {
    PL: 'Dziękujemy za zapis!',
    EN: 'Thank you for subscribing!',
  },
  newsletterSuccessDesc: {
    PL: 'Sprawdź swoją skrzynkę — kod rabatowy już na Ciebie czeka.',
    EN: 'Check your inbox — your discount code is waiting for you.',
  },
  newsletterDisclaimer: {
    PL: 'Nie spamujemy. Możesz się wypisać w każdej chwili.',
    EN: 'We don\'t spam. You can unsubscribe at any time.',
  },
  // Updated Hero
  heroFreeShipping: {
    PL: '✓ Darmowa dostawa od {threshold} zł',
    EN: '✓ Free shipping over {threshold} PLN',
  },
  orderNow: {
    PL: 'Zamów teraz',
    EN: 'Order now',
  },
  giftSets: {
    PL: 'Zestawy prezentowe',
    EN: 'Gift sets',
  },
  hotspotWineTitle: {
    PL: 'Włoskie Wina',
    EN: 'Italian Wines',
  },
  hotspotWineDesc: {
    PL: 'Odkryj naszą kolekcję',
    EN: 'Discover our collection',
  },
  hotspotOilTitle: {
    PL: 'Oliwa z Oliwek',
    EN: 'Olive Oil',
  },
  hotspotOilDesc: {
    PL: 'Tłoczona na zimno',
    EN: 'Cold pressed',
  },
  hotspotSnacksTitle: {
    PL: 'Tradycyjne Przekąski',
    EN: 'Traditional Snacks',
  },
  hotspotSnacksDesc: {
    PL: 'Prawdziwy smak Apulii',
    EN: 'True taste of Puglia',
  },
  // Updated Categories
  whatWePrepared: {
    PL: 'Co dla Ciebie przygotowaliśmy',
    EN: 'What we\'ve prepared for you',
  },
  browseLink: {
    PL: 'Przeglądaj',
    EN: 'Browse',
  },
  productsCount: {
    PL: 'produktów',
    EN: 'products',
  },
  // ProductCard badges
  bestsellerBadge: {
    PL: 'Polecamy',
    EN: 'Recommended',
  },
  lastItems: {
    PL: 'Ostatnie sztuki!',
    EN: 'Last items!',
  },
  saleBadge: {
    PL: 'Promocja',
    EN: 'Sale',
  },
  pageNotFoundTitle: {
    PL: 'Strona nie została odnaleziona',
    EN: 'Page Not Found',
  },
  pageNotFoundSubtitle: {
    PL: 'Przepraszamy, ale strona, której szukasz, nie istnieje lub została przeniesiona pod inny adres.',
    EN: 'We are sorry, but the page you are looking for does not exist or has been moved to another address.',
  },
  pageNotFoundSubText: {
    PL: 'Może zainteresuje Cię nasza oferta?',
    EN: 'Maybe you would be interested in our offer?',
  },
  day_mon: { PL: 'Poniedziałek', EN: 'Monday' },
  day_tue: { PL: 'Wtorek', EN: 'Tuesday' },
  day_wed: { PL: 'Środa', EN: 'Wednesday' },
  day_thu: { PL: 'Czwartek', EN: 'Thursday' },
  day_fri: { PL: 'Piątek', EN: 'Friday' },
  day_sat: { PL: 'Sobota', EN: 'Saturday' },
  day_sun: { PL: 'Niedziela', EN: 'Sunday' },
  closed: { PL: 'Zamknięte', EN: 'Closed' },
  open: { PL: 'Otwarte', EN: 'Open' },
};

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string, replacements?: Record<string, string | number>) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguageState] = useState<Language>(() => {
    try {
      const saved = localStorage.getItem('preferredLanguage');
      if (saved === 'PL' || saved === 'EN') return saved;
    } catch {}
    return 'PL';
  });

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    try {
      localStorage.setItem('preferredLanguage', lang);
    } catch {}
  };

  const t = (key: string, replacements?: Record<string, string | number>): string => {
    let translation = translations[key]?.[language] || key;
    if (replacements) {
      Object.entries(replacements).forEach(([k, v]) => {
        translation = translation.replace(`{${k}}`, String(v));
      });
    }
    return translation;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
